import { render, staticRenderFns } from "./additional-data-input.vue?vue&type=template&id=79304b80&scoped=true&"
import script from "./additional-data-input.vue?vue&type=script&lang=js&"
export * from "./additional-data-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79304b80",
  null
  
)

export default component.exports